import * as React from 'react'
import { useCallback, useEffect, useState } from 'react'
import { InputActionMeta } from 'react-select'
import { Select as SphinxSelect, SelectProps } from './select'
import { OptionTypeBase } from '../../interface/optionTypeBase'

function EditableSelectWithRef<
  OptionType extends OptionTypeBase = { label: string; value: string }
>(
  {
    value,
    inputValue = '',
    onInputChange = () => {},
    onFocus = () => {},
    ...props
  }: SelectProps<OptionType>,
  ref: React.RefObject<any>
) {
  const [currentInputValue, setCurrentInputValue] = useState(inputValue)

  useEffect(() => {
    setCurrentInputValue(inputValue)
  }, [inputValue])

  const handleInputChange = useCallback(
    (newValue: string, action: InputActionMeta) => {
      setCurrentInputValue(newValue)
      onInputChange(newValue, action)
    },
    [onInputChange]
  )

  const handleFocus = useCallback(
    (e: React.FocusEvent<HTMLInputElement>) => {
      if (value) {
        setCurrentInputValue((value as OptionType).label)
      }
      onFocus(e)
    },
    [value]
  )
  return (
    <SphinxSelect<OptionType>
      {...props}
      value={value}
      inputValue={currentInputValue}
      onInputChange={handleInputChange}
      onFocus={handleFocus}
      blurInputOnSelect={true}
      ref={ref}
    />
  )
}

export const EditableSelect = React.forwardRef(EditableSelectWithRef) as <
  OptionType extends OptionTypeBase = { label: string; value: string }
>(
  props: SelectProps<OptionType> & { ref?: React.RefObject<any> }
) => ReturnType<typeof EditableSelectWithRef>
